import firebase from "firebase/app";

export const getAllUsersByName = async (searchTerm) => {
  const usersData = [];

  await firebase
    .firestore()
    .collection("users")
    .where("private", "==", false)
    .where("userNameForSearch", ">=", searchTerm.toLowerCase())
    .where("userNameForSearch", "<=", searchTerm.toLowerCase() + "\uf8ff")
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        usersData.push(doc.data());
      });
    })
    .catch((e) => {
      console.error("Couldn't fetch users", e);
    });

  return usersData;
};
